function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

import "antd/es/upload/style";
import _Upload from "antd/es/upload";
import "antd/es/modal/style";
import _Modal from "antd/es/modal";
import "antd/es/button/style";
import _Button from "antd/es/button";
import "antd/es/icon/style";
import _Icon from "antd/es/icon";
var _excluded = ["value", "$sui"],
    _excluded2 = ["rules", "format", "defaultValue", "id", "verifyTriggers", "children", "onVerify", "labelId", "maxLength", "uploadButton", "hideBtnMaxLength", "buttonText", "hideDefaultErrorMsg", "onPreview", "componentStyle", "name", "filename", "help"];

var _class;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  Object.defineProperty(subClass, "prototype", {
    value: Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    }),
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import { $attrs } from "../sui/bind";
import classnames from "classnames";
import createFormComponent from '../sui/createFormComponent';

var SuiUpload = createFormComponent(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(SuiUpload, _React$Component);

  var _super = _createSuper(SuiUpload);

  function SuiUpload(props, context) {
    var _this;

    _classCallCheck(this, SuiUpload);

    _this = _super.call(this, props, context);
    _this.fileList = [];
    _this.defaultRuleMsgs = {
      maxLength: "最多上传$value个文件",
      minLength: "最少上传$value个文件"
    };

    _this.changeHandler = function (val) {
      _this.changeValue(val);
    };

    _this.previewHandler = function (file) {
      if (typeof _this.props.onPreview === "function" && false === _this.props.onPreview.call(_assertThisInitialized(_this), file)) {
        return false;
      }

      if (file.response) {
        file = file.response;
      }

      _this.setState({
        previewVisible: true,
        previewImage: file.url || file.preview || file.thumbUrl || ""
      });
    };

    _this.previewCancel = function () {
      _this.setState({
        previewVisible: false
      });
    };

    _this.getRefDOM = function (node) {
      if (node && _this.refDOM !== node) {
        _this.refDOM = node;
      }

      return _this.refDOM;
    };

    _this.getRefInstance = function (node) {
      if (node && _this.refInstance !== node) {
        _this.refInstance = node;
      }

      return _this.refInstance;
    };

    _this.onBlur = function (e) {
      _this.blurHandler(e);
    };

    _this.onFocus = function (e) {
      _this.focusHandler(e);
    };

    var defaultValue = props.defaultValue,
        fileList = props.fileList;
    _this.attrs = $attrs({
      value: defaultValue || [],
      readOnly: false,
      disabled: false,
      uploading: false
    });

    _this.attrs.$sui.attach(props, _assertThisInitialized(_this), context);

    _this.state = {
      isMax: _this.isMax(),
      previewImage: "",
      previewVisible: false
    };
    _this.fileList = fileList || defaultValue || [];

    _this.verify("init");

    return _this;
  }

  _createClass(SuiUpload, [{
    key: "isMax",
    value: function isMax() {
      var len = this.fileList.length > this.attrs.value.length ? this.fileList.length : this.attrs.value.length;
      return len && this.props.maxLength && len >= this.props.maxLength;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var responseFilter = this.props.responseFilter;
      var files = [];
      this.fileList.forEach(function (file) {
        if (file && (!file.status || file.status === 'done')) {
          if (file.response) {
            file.response.uid = file.uid;
            file.response.status = file.response.status || "done";
            files.push(typeof responseFilter === 'function' ? responseFilter(file.response) : file.response);
          } else {
            files.push(file);
          }
        }
      });
      return files;
    } // onChange修改value值

  }, {
    key: "changeValue",
    value: function changeValue(info) {
      this.fileList = info.fileList;

      if (this.props.onChange) {
        this.props.onChange.call(this, info);
      }

      if (info.file && /done|removed/.test(info.file.status)) {
        this.attrs.value = this.getValue(); // this.verify("change");
      }

      this.setState({
        isMax: this.isMax()
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      this.getRefInstance().focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.getRefInstance().blur();
    }
  }, {
    key: "doRender",
    value: function doRender() {
      console.log(" ==== render upload ==== ", this.attrs.value);

      var _this$attrs = this.attrs,
          _this$attrs$value = _this$attrs.value,
          value = _this$attrs$value === void 0 ? [] : _this$attrs$value,
          $sui = _this$attrs.$sui,
          attrs = _objectWithoutProperties(_this$attrs, _excluded);

      var _$sui$restProps = $sui.restProps,
          rules = _$sui$restProps.rules,
          format = _$sui$restProps.format,
          defaultValue = _$sui$restProps.defaultValue,
          _$sui$restProps$id = _$sui$restProps.id,
          id = _$sui$restProps$id === void 0 ? this.uuid : _$sui$restProps$id,
          verifyTriggers = _$sui$restProps.verifyTriggers,
          children = _$sui$restProps.children,
          onVerify = _$sui$restProps.onVerify,
          labelId = _$sui$restProps.labelId,
          maxLength = _$sui$restProps.maxLength,
          uploadButton = _$sui$restProps.uploadButton,
          hideBtnMaxLength = _$sui$restProps.hideBtnMaxLength,
          _$sui$restProps$butto = _$sui$restProps.buttonText,
          buttonText = _$sui$restProps$butto === void 0 ? '上传' : _$sui$restProps$butto,
          hideDefaultErrorMsg = _$sui$restProps.hideDefaultErrorMsg,
          onPreview = _$sui$restProps.onPreview,
          componentStyle = _$sui$restProps.componentStyle,
          name = _$sui$restProps.name,
          _$sui$restProps$filen = _$sui$restProps.filename,
          filename = _$sui$restProps$filen === void 0 ? 'file' : _$sui$restProps$filen,
          help = _$sui$restProps.help,
          props = _objectWithoutProperties(_$sui$restProps, _excluded2);

      var _this$state = this.state,
          previewVisible = _this$state.previewVisible,
          previewImage = _this$state.previewImage;
      var validated = this.verifyResult; // 值校验
      // let errorMsg;
      // if (validated.hasError && !hideDefaultErrorMsg) {
      //     errorMsg = this.getDefaultErrorMsg(validated.errorMsg);
      // }

      var classNames = classnames("sui-component sui-upload", {
        'has-error': validated.hasError,
        'sui-component-readonly': attrs.readOnly,
        'sui-component-disabled': attrs.disabled
      });

      if (!uploadButton && uploadButton !== false) {
        if (props.listType && props.listType === "picture-card") {
          uploadButton = /*#__PURE__*/React.createElement("div", {
            className: "sui-upload-btn"
          }, /*#__PURE__*/React.createElement(_Icon, {
            type: "plus"
          }), /*#__PURE__*/React.createElement("div", {
            className: "ant-upload-text"
          }, buttonText));
        } else {
          uploadButton = /*#__PURE__*/React.createElement(_Button, {
            className: "sui-upload-btn"
          }, /*#__PURE__*/React.createElement(_Icon, {
            type: "upload"
          }), " ", buttonText);
        }
      }

      if ((this.isMax() || this.state.isMax) && hideBtnMaxLength) {
        uploadButton = null;
      }

      return /*#__PURE__*/React.createElement("div", {
        style: componentStyle,
        id: id,
        ref: this.getRefDOM,
        className: classNames
      }, /*#__PURE__*/React.createElement(_Modal, {
        visible: previewVisible,
        footer: null,
        onCancel: this.previewCancel
      }, /*#__PURE__*/React.createElement("img", {
        alt: "",
        style: {
          width: '100%'
        },
        src: previewImage
      })), /*#__PURE__*/React.createElement(_Upload, _extends({
        id: labelId
      }, props, attrs, {
        name: filename,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        defaultFileList: value,
        onChange: this.changeHandler,
        onPreview: this.previewHandler,
        ref: this.getRefInstance
      }), uploadButton));
    }
  }, {
    key: "render",
    value: function render() {
      return this.doRender();
    }
  }]);

  return SuiUpload;
}(React.Component)) || _class;

export default SuiUpload;